import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import classNames from "classnames";

import { Client } from "resourceModels";
import { getResource } from "selectors/resources";

import SvgIcon from "components/Common/SvgIcon";
import DevToolbarClientFeatures from "./DevToolbarClientFeatures";

import "./style.scss";

const BLOCK_NAME = "DevToolbar";

export class DevToolbar extends React.PureComponent {
  state = {
    isExpanded: false
  };

  handleToggleBound = this.handleToggle.bind(this);

  /**
   * Handlers
   */

  /**
   */
  handleToggle() {
    const { isExpanded } = this.state;

    this.setState({
      isExpanded: !isExpanded
    });
  }

  /**
   * Methods
   */

  /**
   * @returns {ReactElement|null}
   */
  render() {
    const { client } = this.props;
    const { isExpanded } = this.state;

    if (!client) {
      return null;
    }

    return (
      <div
        className={classNames(BLOCK_NAME, {
          [`${BLOCK_NAME}--expanded`]: isExpanded
        })}
      >
        <button type="button" className={`${BLOCK_NAME}__toggle`} onClick={this.handleToggleBound}>
          DevTools
          <span className={`${BLOCK_NAME}__toggle-icon`}><SvgIcon icon="Close" /></span>
        </button>

        <div className={`${BLOCK_NAME}__content`}>
          <DevToolbarClientFeatures />
        </div>

        <div className={`${BLOCK_NAME}__shadow-thing`} />
      </div>
    );
  }
}

DevToolbar.propTypes = {
  client: PropTypes.instanceOf(Client)
};

DevToolbar.defaultProps = {
  client: null
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client")
  };
}

const Connector = connect(mapStateToProps)(DevToolbar);

Connector.propTypes = {};
Connector.defaultProps = {};

export default Connector;
